import React from 'react';
import NavButton from '../../homepage/header-banner/TopNavButton';
import TrafficFee from '../../homepage/header-banner/TrafficFee';
import MySql from '../../homepage/header-banner/MySql';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import CardBox from '../../container/Box/Components/CardBox'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import ClickHouse from '../../homepage/header-banner/ClickHouse';
import '../../Style/typo.css'
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import BannerPrivateCloudENG from '../../container/Banner/banner-privateCloud-en';
import Cloudconsult2ENG from '../../homepage/consult/cloudconsult-2-en';
import SidebarENG from '../../container/Sidebar/Sidebar-en';
import HeaderEn from '../../detailpageVN/Page/component/headeren';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

function ClusterclickhouseENG() {
    const isMobile = useIsMobile();
    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudENG />
            <Container className='main-body'>
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarENG />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for ClickHouse")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}

                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Open-source Columnar DBMS for Real-time Online Analytical Processing (OLAP)</p>",
                                `<p class="typo-14">Data is recorded on available nodes and then replicated across all nodes.</p>
                                <p class="typo-14">Capable of storing and processing petabyte-scale data.</p>
                                <p class="typo-14">Achieves more than 100 times faster performance than traditional DBMS and is used for real-time online data analytics.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Distributes data across shards and supports asynchronous multi-master replication</p>",
                                `<p class="typo-14">Supports multi-master asynchronous replication, collecting data from any replicated node.</p>
                                <p class="typo-14">Stores data in shards, executes operations in parallel, and merges results.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Operates high-performance Persistent Volumes with optimized I/O performance</p>",
                                `<p class="typo-14">Operated on SSD-based PV volumes, with 3 replica containers (PODs) forming a single service unit.</p>
                                <p class="typo-14">Services continue on replica containers (PODs) on other worker nodes even during hardware failures.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Implements a zero-downtime system that automatically reassigns containers (PODs) to other worker nodes during hardware failures</p>",
                                `<p class="typo-14">Kubernetes ClickHouse containers (PODs) are configured with 3 replica nodes per service unit.</p> 
                                <p class="typo-14">Each replica container (POD) is distributed across multiple Kubernetes worker nodes.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Automatically performs autoscaling to expand containers and balance service load</p>",
                                `<p class="typo-14">Periodically adjusts the number of containers (PODs) based on CPU, memory, or other custom metrics.</p>
                                <p class="typo-14">Enables service operation without additional hardware resources for scaling.</p>
                                <p class="typo-14">A cluster solution that improves load balancing and cost efficiency for scalable, reliable service deployment.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>{Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-clickhouse/clickhouse.jpeg")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        {/* <ClickHouse />
                        <TrafficFee /> */}
                        {/* <CloudconsultCp /> */}
                        <Cloudconsult2ENG />
                    </Col>
                </Row>
            </Container>
            {/* <Cloudconsult /> */}
            {/* <Footer /> */}
            <FooterEn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default ClusterclickhouseENG;
